// ANGULAR DEPENDENCY
import { NgModule } from '@angular/core';

// NGRX
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

// STORE REDUCER AND EFFECTS
import { BusinessEffects } from './store/effects';
import * as fromBusiness from './store/reducer';

// SERVICES
import { BusinessStoreService } from './business-store.service';
import { BusinessService } from './services/business.service';


/**
 * Local storage sync function for sync store state keys with local storage
 */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({ keys: ['business'], rehydrate: true })(reducer);
}

// add localstorage function in meta reducers
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

/**
 * This module is for configure Business ngrx related stuff.
 *
 *   @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 * Notes:-
 * Date: 4-24-2020 business store module created
 */
@NgModule({
  imports: [
    StoreModule.forFeature('business', fromBusiness.reducer, { metaReducers }),
    EffectsModule.forFeature([BusinessEffects]),
  ],
  declarations: [],
  providers: [
    BusinessService,
    BusinessStoreService,
  ],
})
export class BusinessStoreModule { }
